export default __webpack_public_path__ + "static/KatarzynaWójcik-6ec9e4eca283b8cf3295fc908c6d2152.png";